import { render, staticRenderFns } from "./TicketContent.vue?vue&type=template&id=5f788eda"
import script from "./TicketContent.vue?vue&type=script&lang=js"
export * from "./TicketContent.vue?vue&type=script&lang=js"
import style0 from "./TicketContent.vue?vue&type=style&index=0&id=5f788eda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports